'use strict';

var React              = require('react'),
    _                  = require('underscore'),
    ApplicationActions = require('js/shared/actions/application-actions.js');

var TextInput        = require('js/screens/form/input/text.jsx'),
    DropdownInput    = require('js/screens/form/input/unidropdown.jsx'),
    CheckboxInput    = require('js/screens/form/input/checkbox.jsx'),
    RadiobuttonInput = require('js/screens/form/input/radiobutton.jsx'),
    QuestionInput    = require('js/screens/form/application-question-input.jsx');

var TYPES      = require('js/shared/utils/input-types.js').TYPES,
    STAGES     = require('js/shared/utils/application-stages.js');

var ReviewPage = React.createClass({

  propTypes: {
    values: React.PropTypes.any.isRequired, // should be dict?
    questions: React.PropTypes.any.isRequired, // array of dicts
    errors: React.PropTypes.objectOf(React.PropTypes.bool).isRequired,
    application: React.PropTypes.any
  },

  _changeAppStage: function(toStage) {
    ApplicationActions.submitApplication({
      application: this.props.application,
      review: true
    });
  },

  _renderElements: function() {
    return _.map(this.props.questions, function(question) {
      var hasError = true;
      if(this.props.errors[question.fieldName] !== undefined) {
        hasError = this.props.errors[question.fieldName];
      }
      return (
        <QuestionInput
          hasError={hasError}
          onReview={true}
          {...question}
          value={this.props.values[question.fieldName]} />
      );
    }.bind(this));
  },

  render: function() {
    var anyErrors = _.some(this.props.errors, x => x === true);

    var buttonDisabled = anyErrors || this.props.application.submitting;
    return (
      <div className="review-page">
        {this._renderElements()}
        <button
          className="htn-button htn-button--review"
          onClick={this._changeAppStage.bind(null, STAGES.SUBMITTED)}
          disabled={buttonDisabled}>
          {this.props.application.submitting ? "Submitting..." : "Submit"}
        </button>
      </div>
    );
  }
});

module.exports = ReviewPage;



/** WEBPACK FOOTER **
 ** ./js/screens/form/application-reviewpage.jsx
 **/